import {
  Drawer as DrawerType,
  MelcoModelsUserSerialNumber,
} from "melco-shared-logic";
import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { AssignUserList } from "./AssignUserList";

type AssignUserDrawerProps = {
  product_code?: string | null;
  license: MelcoModelsUserSerialNumber;
  drawer: DrawerType;
};

export const AssignUserDrawer: React.FC<AssignUserDrawerProps> = ({
  drawer,
  license,
  product_code,
}) => {
  const { t } = useTranslation();
  const { closeDrawer, isDrawerOpen } = drawer;

  return (
    <Drawer
      title={t("infrastructureLicenses.actions.assign.title")}
      placement="right"
      width={1000}
      closable={true}
      onClose={closeDrawer}
      open={isDrawerOpen}
      bodyStyle={{ padding: 0 }}
      destroyOnClose
    >
      <AssignUserList
        product_code={product_code}
        drawer={drawer}
        license={license}
      />
    </Drawer>
  );
};
